import { Platform } from 'react-native'

import { useIntl } from 'react-intl'

import Stack from 'app/components/base/Stack'
import Text from 'app/components/base/Text'
import ChipLabel from 'app/components/common/ChipLabel'
import { userRoleText } from 'app/utils/constants/role.constants'

type NameWithLabelProps = {
  name?: string
  role: string
}

const NameWithLabel: RFC<NameWithLabelProps> = ({ name, role }) => {
  const intl = useIntl()
  const chipText = userRoleText[role]

  return (
    <Stack
      {...Platform.select({
        web: { direction: { md: 'row', xs: 'column' } },
        native: { direction: 'column' }
      })}
      spacing={{ md: 2, xs: 1 }}
      sx={{ alignItems: { md: 'center', xs: 'flex-start' } }}
    >
      <Text
        variant="h5"
        lineClamp={2}
        sx={{
          color: 'common.white',
          fontWeight: { md: 400 },
          fontFamily: 'Nunito',
          fontSize: { md: 30 },
          lineHeight: {
            ...Platform.select({
              web: { md: '35px' },
              native: { md: 35 }
            })
          }
        }}
      >
        {name}
      </Text>

      <ChipLabel sx={{ px: 1 }}>
        <Text
          variant="subtitle1"
          sx={{
            maxHeight: 22,
            fontWeight: 500,
            fontSize: 12
          }}
        >
          {intl.formatMessage(chipText)}
        </Text>
      </ChipLabel>
    </Stack>
  )
}

export default NameWithLabel
